import React, { forwardRef } from 'react'
import { InputGroup, Input, Select } from '@ow/comps'
import dittoFilter from '../ditto/register.filter'
import { customStyles } from './styles'

// 筛选条件
const QueryType = ({
  alowedqueryTypes = [],
  currentQueryType,
  onChange,
  style,
}) => {
  const defaultQueryType = alowedqueryTypes[0] || {}

  return (
    <div>
      {alowedqueryTypes.length === 1 ? (
        <Input
          style={style}
          className="left-input"
          defaultValue={defaultQueryType.label}
          onChange={(e) => {
            onChange(e.value)
          }}
          disabled
          allowClear={false}
        />
      ) : (
        <Select
          options={alowedqueryTypes}
          styles={customStyles(style)}
          onChange={(e) => {
            onChange(e)
          }}
          defaultValue={defaultQueryType}
          value={
            alowedqueryTypes.find((v) => v.value === currentQueryType) ||
            defaultQueryType
          }
          noOptionsMessage={() => '暂无数据'}
          allowClear={false}
        />
      )}
    </div>
  )
}

export const FieldValue = forwardRef(
  (
    {
      field = {},
      onChange,
      value,
      onFetchRemoteData,
      filters,
      hiddenQueryType,
      hiddenItem,
      valueStyle = {},
      currentQueryType,
      fieldIsDisabled,
    },
    ref
  ) => {
    const Widget = dittoFilter.render(field.type)
    if (!Widget) {
      return null
    }
    // console.log(ref)

    return (
      <Widget
        ref={ref}
        opts={{
          ...field,
          readonly: false,
          hidden: hiddenItem,
          fieldIsDisabled,
          currentQueryType,
        }}
        style={{
          borderBottomLeftRadius: !hiddenQueryType && 0,
          borderTopLeftRadius: !hiddenQueryType && 0,
          width: '235px',
          minWidth: '235px',
          maxWidth: '235px',
          height: '34px',
          color: 'var(--ow-color-gray-300)',
          paddingLeft: '8px',
          ...valueStyle,
        }}
        value={value}
        onChange={(e) => {
          if (onChange) {
            onChange(e)
          }
        }}
        onFetchRemoteData={onFetchRemoteData}
        filters={filters}
      />
    )
  }
)

const FilterItem = (
  {
    filterField,
    // currentQueryType,
    alowedqueryTypes,
    value = '',
    onChange,
    onFetchRemoteData,
    filters,
    hiddenQueryType,
    hiddenItem,
    valueStyle,
    fieldIsDisabled,
  },
  ref
) => {
  const currentQueryType = Array.isArray(value.queryType)
    ? value.queryType[0]
    : value.queryType

  const onQueryTypeChange = (e) => {
    if (onChange) {
      const queryType = Array.isArray(e.value) ? e.value[0] : e.value
      const isDisabled = fieldIsDisabled(queryType)
      const finalVal = isDisabled ? { ...value, value: '' } : value
      onChange({
        ...finalVal,
        queryType,
      })
    }
  }

  const onFiledValueChange = (val) => {
    if (onChange) {
      onChange({
        ...value,
        value: val,
      })
    }
  }

  return (
    // <div className="flex flex-row items-center">
    <InputGroup
      style={{
        // 平铺的筛选不需要定高度
        height: filterField && filterField.type !== 'select' && '34px',
        marginRight: '10px',
      }}
      className="flex flex-row"
    >
      {!hiddenQueryType && (
        <QueryType
          style={{
            height: '100%',
            width: '80px',
            borderBottomRightRadius: 0,
            borderTopRightRadius: 0,
            borderRightWidth: 0,
            paddingLeft: '11px',
          }}
          currentQueryType={currentQueryType}
          alowedqueryTypes={alowedqueryTypes}
          onChange={onQueryTypeChange}
        />
      )}

      <FieldValue
        ref={ref}
        field={filterField}
        queryType={filterField.queryType}
        value={value.value}
        onChange={onFiledValueChange}
        onFetchRemoteData={onFetchRemoteData}
        filters={filters}
        hiddenQueryType={hiddenQueryType}
        hiddenItem={hiddenItem}
        valueStyle={valueStyle}
        currentQueryType={currentQueryType}
        fieldIsDisabled={fieldIsDisabled(currentQueryType)}
      />
    </InputGroup>
    // </div>
  )
}

export default forwardRef(FilterItem)
